import { render, staticRenderFns } from "./tooltip-button.vue?vue&type=template&id=bd49f1bc&"
import script from "./tooltip-button.vue?vue&type=script&lang=ts&"
export * from "./tooltip-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports